import baseApi from '../common/apis/base-api';

export const fetchApiVersionDetails = () => {
  return baseApi.get<any>(`/signature`).then(response => {
    return response.data;
  });
};
